import BankSelect from 'components/BankSelect';
import { Button, FormInput, Icon } from 'modules';
import { moneyFormat } from 'modules';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

export interface BankAccount {
  bankName: string;
  balance: number;
}

interface BankAccountsListProps {
  name: string;
  list: BankAccount[];
  readOnly?: boolean;
  onChange: (e: React.ChangeEvent) => void;
}

const BankAccountsList = ({ name, list, readOnly, onChange }: BankAccountsListProps) => {
  const [newRow] = useState(true);
  const [newRowData, setNewRowData] = useState<BankAccount>({
    bankName: '',
    balance: 0,
  });

  const onChangeNewRowData = (e: React.ChangeEvent) => {
    const { name, value } = e.target as HTMLInputElement;
    setNewRowData({
      ...newRowData,
      [name]: value,
    });
  };

  const isValid = (): boolean => {
    return newRowData.bankName !== '' && newRowData.balance > 0;
  };

  const onSaveNewRow = (): void => {
    if (isValid()) {
      const newAccounts = [...list];
      newAccounts.push(newRowData);
      onChange({
        target: {
          name,
          value: newAccounts,
        },
      } as any);
      setNewRowData({
        bankName: '',
        balance: 0,
      });
    }
  };

  const onDeleteRow = (index: number): void => {
    const newAccounts = list.filter((b, i: number) => i !== index);
    onChange({
      target: {
        name,
        value: newAccounts,
      },
    } as any);
  };

  return (
    <>
      {list.map((a: BankAccount, index: number) => {
        return (
          <Row key={index}>
            <Col sm={9}>
              <FormInput name="bankName" value={a.bankName} readOnly={true} />
            </Col>
            <Col sm={3} className="d-flex">
              <FormInput name="balance" className="text-right" value={moneyFormat(a.balance)} readOnly={true} />
              {readOnly !== true && (
                <Button
                  type="button"
                  variant="danger"
                  className="btn-input-size ml-1"
                  onClick={() => onDeleteRow(index)}
                >
                  <Icon type="times" />
                </Button>
              )}
            </Col>
          </Row>
        );
      })}

      {newRow === true && readOnly !== true && (
        <Row>
          <Col sm={9}>
            <BankSelect
              name="bankName"
              required={true}
              outputValue={(b: GQL.IBank) => b.banka}
              placeholder="Banka"
              value={newRowData.bankName}
              onChange={onChangeNewRowData}
            />
          </Col>
          <Col sm={3} className="d-flex">
            <FormInput
              type="number"
              name="balance"
              className="text-right"
              placeholder="Zostatok (EUR)"
              value={newRowData.balance}
              onChange={onChangeNewRowData}
            />
            <Button
              type="button"
              variant="primary"
              disabled={!isValid()}
              className="btn-input-size ml-1"
              onClick={onSaveNewRow}
            >
              <Icon type="check" />
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default BankAccountsList;
